import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  VStack,
  Flex,
  Text,
  Button,
  IconButton,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  SimpleGrid,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  FormControl,
  FormLabel,
  Select,
  useDisclosure,
  useToast,
  Tabs,
  TabList,
  Input,
  Checkbox,
  Tab,
  TabPanels,
  TabPanel,
  Table,
  Thead,
  Icon,
  Tbody,
  Tr,
  Th,
  Td,
  Menu,
  useColorModeValue,
  MenuButton,
  MenuList,
  MenuItem,
} from "@chakra-ui/react";

import {
  FaPlus,
  FaEdit,
  FaMarker,
  FaEllipsisV,
  FaSync,
  FaBook,
  FaCalendarAlt,
  FaChalkboardTeacher,
  FaClipboardList,
  FaListAlt,
  FaPercent,
  FaUserTie,
  FaCheckCircle,
  FaPrint,
} from "react-icons/fa";
import axios from "axios";
import { Link } from "react-router-dom";
import Print_Pdf_Exam_details from "./Print_Pdf_Exam_details";
import { BASE_URL } from "../../Globalapi/Globalapi";

const ExamDetails = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isSectionOpen,
    onOpen: onSectionOpen,
    onClose: onSectionClose,
  } = useDisclosure();
  const toast = useToast();

  // State variables
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const printComponentRef = useRef();
  const [exams, setExams] = useState([]);
  const [categories, setCategories] = useState([]);
  const [staff, setStaff] = useState([]);
  const [subjects, setSubjects] = useState([]); // State for subjects
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState(
    () => localStorage.getItem("selectedClass") || ""
  );
  const [selectedSubject, setSelectedSubject] = useState(""); // State for selected subject
  const [userType, setUserType] = useState(
    sessionStorage.getItem("user_type") || null
  );
  const [activeTabIndex, setActiveTabIndex] = useState(0); // State for active tab index
  const [examDate, setExamDate] = useState("");
  const [isClassTest, setIsClassTest] = useState(0);
  const [isEditing, setIsEditing] = useState(false);
  const [currentExamId, setCurrentExamId] = useState(null);
  const [category, setCategory] = useState("");
  const [examName, setExamName] = useState("");
  const [maxMark, setMaxMark] = useState("");
  const [passMark, setPassMark] = useState("");
  const [staffSearch, setStaffSearch] = useState("");
  const [selectedStaff, setSelectedStaff] = useState("");
  const [filteredSubjects, setFilteredSubjects] = useState([]);

  const [academicId, setAcademicId] = useState(
    sessionStorage.getItem("Academic")
  );

  useEffect(() => {
    const handleStorageChange = () => {
      setAcademicId(sessionStorage.getItem("Academic"));
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  // Fetch data on component mount
  const fetchData = async () => {
    try {
      const jwtToken = sessionStorage.getItem("jwt");
      if (!jwtToken) {
        throw new Error("JWT token not found");
      }
      const school_id = sessionStorage.getItem("school_id");

      // Fetch exams, categories, staff, and classes
      const [examsRes, categoriesRes, staffRes, classesRes] = await Promise.all(
        [
          axios.get(
            `${BASE_URL}/admin/exam/list_all_exams.php?school_id=${school_id}`,
            {
              headers: { Authorization: `Bearer ${jwtToken}` },
            }
          ),
          axios.get(`${BASE_URL}/admin/exam/exam_category.php`),
          axios.get(
            `${BASE_URL}/admin/staff/staff_list.php?school_id=${school_id}`
          ),
          axios.get(`${BASE_URL}/admin/class/class_master.php`),
        ]
      );

      // Filter exams by academic year ID
      const allExams = examsRes.data.data || [];
      console.log("Exam details:", allExams);
      const filteredExams = allExams.filter(
        (exam) => exam.academic_year_id === academicId
      );
      setExams(filteredExams);

      setCategories(categoriesRes.data.data || []);
      setStaff(staffRes.data.data || []);
      setClasses(classesRes.data.data || []);
      setIsDataLoaded(true);

      // Fetch subjects
      const subjectsRes = await axios.get(
        `${BASE_URL}/admin/subject/list_subject.php`
      );
      setSubjects(subjectsRes.data.data || []);
      console.log(subjectsRes.data.data);
    } catch (error) {
      toast({
        title: "Error fetching data.",
        description: "An error occurred while fetching data.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (academicId) {
      fetchData();
    }
  }, [academicId]); // Fetch data whenever academicId changes

  const handlePrint = () => {
    // Only trigger print if data is fully loaded
    if (isDataLoaded && printComponentRef.current) {
      printComponentRef.current.handlePrint();
    } else {
      console.log("Data is still loading...");
    }
  };
  // Store selected class in localStorage when it changes
  useEffect(() => {
    if (selectedClass) {
      localStorage.setItem("selectedClass", selectedClass);
    }
    // Reset selected subject when the selected class changes
    setSelectedSubject(""); // Reset selected subject
  }, [selectedClass]);

  // Reset selected class when the active tab changes
  useEffect(() => {
    setSelectedClass(""); // Reset selected class
  }, [activeTabIndex]);

  // Group exams by category for rendering tabs
  const groupedExams = exams.reduce((acc, exam) => {
    const category = exam.category || "Uncategorized";
    if (!acc[category]) acc[category] = [];
    acc[category].push(exam);
    return acc;
  }, {});

  const handleSubmit = () => {
    if (
      !examName ||
      !maxMark ||
      !passMark ||
      !selectedStaff ||
      !selectedSubject ||
      !category ||
      !selectedClass
    ) {
      toast({
        title: "Validation Error",
        description: "Please fill all required fields.",
        status: "warning",
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    const examData = {
      caption_exam: examName,
      max_marks: maxMark,
      pass_marks: passMark,
      contact_staff_id: selectedStaff,
      subject_id: selectedSubject,
      exam_category_id: category,
      class_id: selectedClass,
      exam_date: examDate,
      class_test: isClassTest,
      pass: sessionStorage.getItem("user_id"),
      exam_id: currentExamId,
      academic_year_id: academicId,
      school_id: sessionStorage.getItem("school_id"),
    };
    console.log("====================================");
    console.log(examData);
    console.log("====================================", currentExamId);

    const apiUrl = isEditing
      ? `${BASE_URL}/admin/exam/edit_exam.php`
      : `${BASE_URL}/admin/exam/create_exam.php`;

    // Use PUT method for editing an exam
    const requestMethod = isEditing ? "put" : "post";

    axios[requestMethod](apiUrl, examData)
      .then((response) => {
        if (response.data.success) {
          toast({
            title: isEditing ? "Exam updated." : "Exam created.",
            description: isEditing
              ? "The exam has been successfully updated."
              : "The exam has been successfully created.",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          onClose();
          // Refresh exams data
          axios
            .get(`${BASE_URL}/admin/exam/list_all_exams.php`)
            .then((response) => setExams(response.data.data || []))
            .catch((error) => console.error("Error fetching exams:", error));
        } else {
          toast({
            title: "Error saving exam.",
            description:
              response.data.message ||
              "An error occurred while saving the exam.",
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        }
      })
      .catch((error) => {
        toast({
          title: "Error saving exam.",
          description: "An error occurred while saving the exam.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        console.error("Error saving exam:", error);
      });
  };

  // Handle form submission for creating a category
  const handleCategorySubmit = () => {
    if (!category) {
      toast({
        title: "Validation Error",
        description: "Please enter a category name.",
        status: "warning",
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    const categoryData = {
      category: category,
      pass: sessionStorage.getItem("user_id"),
    };

    axios
      .post(`${BASE_URL}/admin/exam/create_exam_category.php`, categoryData)
      .then((response) => {
        if (response.data.success) {
          toast({
            title: "Category created.",
            description: "The category has been successfully created.",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          onSectionClose();
          // Refresh categories data
          axios
            .get(`${BASE_URL}/admin/exam/exam_category.php`)
            .then((response) => setCategories(response.data.data || []))
            .catch((error) =>
              console.error("Error fetching categories:", error)
            );
        } else {
          toast({
            title: "Error creating category.",
            description:
              response.data.message ||
              "An error occurred while creating the category.",
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        }
      })
      .catch((error) => {
        toast({
          title: "Error creating category.",
          description: "An error occurred while creating the category.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        console.error("Error creating category:", error);
      });
  };

  // Handle menu actions for editing and deleting exams
  const handleMenuAction = (action, exam) => {
    switch (action) {
      case "editExam":
        console.log("Editing Exam Data:", {
          caption_exam: exam.caption_exam,
          max_marks: exam.max_marks,
          pass_marks: exam.pass_marks,
          contact_staff_id: exam.contact_staff_id,
          subject_id: exam.subject_id,
          exam_category_id: exam.exam_category_id,
          class_id: exam.class_id,
          id: exam.id,
          pass: sessionStorage.getItem("user_id"),
        });

        setExamName(exam.caption_exam);
        setExamDate(exam.exam_date);
        setMaxMark(exam.max_marks);
        setPassMark(exam.pass_marks);
        setSelectedStaff(exam.contact_staff_id);
        setSelectedSubject(exam.subject_id);
        setCategory(exam.exam_category_id);
        setSelectedClass(exam.class_id);
        setCurrentExamId(exam.id);

        setIsEditing(true);
        onOpen();
        break;

      case "deleteExam":
        console.log("Deleting Exam ID:", exam.id);

        axios
          .delete(`${BASE_URL}/admin/exam/delete_exam.php`, {
            data: { exam_id: exam.id }, // Pass exam_id in the data object
          })
          .then((response) => {
            if (response.data.success) {
              toast({
                title: "Exam deleted.",
                description: "The exam has been successfully deleted.",
                status: "success",
                duration: 5000,
                isClosable: true,
              });
              // Refresh exams data
              axios
                .get(`${BASE_URL}/admin/exam/list_all_exams.php`)
                .then((response) => setExams(response.data.data || []))
                .catch((error) =>
                  console.error("Error fetching exams:", error)
                );
            } else {
              toast({
                title: "Error deleting exam.",
                description:
                  response.data.message ||
                  "An error occurred while deleting the exam.",
                status: "error",
                duration: 5000,
                isClosable: true,
              });
            }
          })
          .catch((error) => {
            toast({
              title: "Error deleting exam.",
              description: "An error occurred while deleting the exam.",
              status: "error",
              duration: 5000,
              isClosable: true,
            });
            console.error("Error deleting exam:", error);
          });
        break;

      default:
        break;
    }
  };

  // Filter staff based on search input
  const filteredStaff = staff.filter((s) =>
    s.name.toLowerCase().includes(staffSearch.toLowerCase())
  );

  useEffect(() => {
    if (selectedClass) {
      fetchClassDetails();
    } else {
      setFilteredSubjects([]);
    }
  }, [selectedClass]);

  const fetchClassDetails = async () => {
    try {
      const jwtToken = sessionStorage.getItem("jwt");
      const response = await axios.get(
        `${BASE_URL}/admin/subject/selected_subjects.php?class_id=${selectedClass}`,
        { headers: { Authorization: `Bearer ${jwtToken}` } }
      );

      if (response.data.success && response.data.selectedSubjects) {
        // Extract IDs of selected subjects for the chosen class
        const selectedSubjectIds = response.data.selectedSubjects;

        // Filter subjects to only include those with matching IDs
        const matchedSubjects = subjects.filter((subject) =>
          selectedSubjectIds.includes(subject.id)
        );
        setFilteredSubjects(matchedSubjects);
      } else {
        console.error("No selected subjects found in the response");
        setFilteredSubjects([]);
      }
    } catch (error) {
      console.error("Error fetching class details:", error);
    }
  };

  return (
    <Box borderRadius="md" mx="auto" bg="white" style={{ marginRight: "1px" }}>
      <div style={{ backgroundColor: "#FBFBFD", height: "100vh" }}>
        <div className="teacher-list-container">
          <div className="header">
            <h1 style={{ fontSize: "20px", margin: 0 }}>Exam Details</h1>
            <div className="action-buttons">
              <div className="export-dropdown">
                <Button
                  className="export-button"
                  display={{ base: "none", md: "flex" }}
                  backgroundColor="white"
                  fontSize="11px"
                  boxShadow="md"
                  onClick={handlePrint} // Attach the print handler here
                >
                  <FaPrint color="#515B73" />
                  Print PDF
                </Button>

                <div style={{ display: "none" }}>
                  <Print_Pdf_Exam_details
                    ref={printComponentRef}
                    categories={categories}
                  />
                </div>
              </div>
              <Flex align="center">
                <Button
                  colorScheme="teal"
                  variant="solid"
                  leftIcon={<FaPlus />}
                  onClick={onOpen}
                  width={{ base: "0", md: "150px" }} // 100% width on mobile, fixed width on larger screens
                  mr={2}
                >
                  <Box display={{ base: "none", md: "block" }}>Add Exam</Box>
                </Button>
                {userType === "1" && (
                  <Button
                    colorScheme="purple"
                    variant="solid"
                    leftIcon={<FaPlus />}
                    onClick={onSectionOpen}
                    mr={2}
                    width={{ base: "0", md: "150px" }} // 100% width on mobile, fixed width on larger screens
                  >
                    <Box display={{ base: "none", md: "block" }}>
                      Add Category
                    </Box>
                  </Button>
                )}
              </Flex>
            </div>
          </div>
          <div className="breadcrumb">
            <Link
              to="/admin"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <span>Dashboard</span>
            </Link>{" "}
            / <span>Exam</span> / <span>Exam Details</span>
          </div>
        </div>
        <Flex mr={{ base: "5" }} justify="flex-end" pl={7}>
          {/* Added padding-right to create space on the right */}
          <FormControl w="auto" pr={2}>
            {/* Adjust padding-right if needed */}
            <FormLabel htmlFor="classSelect" mb={0}></FormLabel>
            <Select
              id="classSelect"
              placeholder="Select class"
              value={selectedClass}
              onChange={(e) => setSelectedClass(e.target.value)}
            >
              {classes.map((classItem) => (
                <option key={classItem.id} value={classItem.id}>
                  {classItem.class}
                </option>
              ))}
            </Select>
          </FormControl>
          <FormControl w="160px" pr={2} mr={{ base: "4", md: "0" }}>
            {/* Set width to 150 pixels, margin-right is 4 on small screens */}
            <FormLabel htmlFor="subjectSelect" mb={0}></FormLabel>
            <Select
              id="subjectSelect"
              placeholder="Select subject"
              value={selectedSubject}
              onChange={(e) => setSelectedSubject(e.target.value)}
            >
              {subjects.map((subject) => (
                <option key={subject.id} value={subject.id}>
                  {subject.subject}
                </option>
              ))}
            </Select>
          </FormControl>
        </Flex>

        {/* Tabs for Exam Categories */}
        <Box p={5} marginBottom={0}>
          <Tabs
            isFitted
            variant="soft-rounded"
            colorScheme="teal"
            index={activeTabIndex}
            onChange={(index) => setActiveTabIndex(index)}
            p={2}
            borderRadius="md"
            bg={useColorModeValue("white", "gray.700")}
          >
            <TabList>
              {Object.keys(groupedExams).map((category) => (
                <Tab
                  key={category}
                  _selected={{
                    bg: "teal.100",
                    color: "teal.800",
                    fontWeight: "bold",
                    borderRadius: "md",
                  }}
                  py={2}
                >
                  {category}
                </Tab>
              ))}
            </TabList>
            <TabPanels>
              {Object.entries(groupedExams).map(([category, exams]) => (
                <TabPanel key={category} p={4}>
                  {/* Conditional rendering for exams based on selected class and subject */}
                  {selectedClass ? (
                    exams.filter(
                      (exam) =>
                        exam.class_id === selectedClass &&
                        (selectedSubject
                          ? exam.subject_id === selectedSubject
                          : true)
                    ).length > 0 ? (
                      <Box overflowX="auto">
                        {" "}
                        {/* Add this Box for horizontal scrolling */}
                        <Table
                          sx={{
                            "tbody tr:nth-of-type(even)": {
                              backgroundColor: "#f2f4f8",
                            },
                          }}
                        >
                          <Thead>
                            <Tr>
                              <Th>
                                <Box textAlign="center">Exam Name</Box>
                              </Th>
                              <Th>
                                <Box textAlign="center">Max Mark</Box>
                              </Th>
                              <Th>
                                <Box textAlign="center">Pass Mark</Box>
                              </Th>
                              <Th>
                                <Box textAlign="center">Staff</Box>
                              </Th>
                              <Th>
                                <Box textAlign="center">Subject</Box>
                              </Th>
                              <Th>
                                <Box textAlign="center">Class</Box>
                              </Th>
                              <Th>
                                <Box textAlign="center">Actions</Box>
                              </Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {exams
                              .filter(
                                (exam) =>
                                  exam.class_id === selectedClass &&
                                  (selectedSubject
                                    ? exam.subject_id === selectedSubject
                                    : true)
                              )
                              .map((exam) => (
                                <Tr key={exam.id}>
                                  <Td>
                                    <Box textAlign="center">
                                      {exam.caption_exam}
                                    </Box>
                                  </Td>
                                  <Td>
                                    <Box textAlign="right">
                                      {exam.max_marks}
                                    </Box>
                                  </Td>
                                  <Td>
                                    <Box textAlign="right">
                                      {exam.pass_marks}
                                    </Box>
                                  </Td>
                                  <Td>
                                    <Box textAlign="center">{exam.name}</Box>
                                  </Td>
                                  <Td>
                                    <Box textAlign="center">{exam.subject}</Box>
                                  </Td>
                                  <Td>
                                    <Box textAlign="center">{exam.class}</Box>
                                  </Td>
                                  <Td p={2} fontSize="sm">
                                    <Box textAlign="center">
                                      <Menu>
                                        <MenuButton
                                          as={IconButton}
                                          icon={<FaEllipsisV />}
                                          variant="ghost"
                                          aria-label="Options"
                                        />
                                        <MenuList>
                                          <MenuItem
                                            onClick={() =>
                                              handleMenuAction("editExam", exam)
                                            }
                                          >
                                            Edit Exam
                                          </MenuItem>
                                          <MenuItem
                                            onClick={() =>
                                              handleMenuAction(
                                                "deleteExam",
                                                exam
                                              )
                                            }
                                          >
                                            Delete Exam
                                          </MenuItem>
                                        </MenuList>
                                      </Menu>
                                    </Box>
                                  </Td>
                                </Tr>
                              ))}
                          </Tbody>
                        </Table>
                      </Box>
                    ) : (
                      <Text color="gray.500" textAlign="center">
                        No exams found for the selected class and subject.
                      </Text>
                    )
                  ) : (
                    <Text color="gray.500" textAlign="center">
                      Please select a class for exam details.
                    </Text>
                  )}
                </TabPanel>
              ))}
            </TabPanels>
          </Tabs>
        </Box>
      </div>
      {/* Exam Modal */}
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="lg"
        motionPreset="slideInBottom"
      >
        <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
        <ModalContent
          borderRadius="lg"
          boxShadow="xl"
          bg="linear-gradient(135deg, #e0f7f7, #f0ffff)"
          color="gray.700"
          p={6}
          maxW="700px"
          maxH="550px"
          overflowY="auto"
        >
          <ModalHeader
            fontSize="xl"
            fontWeight="bold"
            textAlign="center"
            color="teal.600"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Icon as={isEditing ? FaEdit : FaPlus} boxSize={5} mr={2} />
            {isEditing ? "Edit Exam Details" : "Create Exam Details"}
          </ModalHeader>{" "}
          <ModalCloseButton />
          <ModalBody
            overflowY="auto"
            px={4}
            css={{
              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-track": {
                background: "rgba(255, 255, 255, 0.2)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "rgba(173, 216, 230, 0.6)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "rgba(173, 216, 230, 0.9)",
              },
            }}
          >
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
              <FormControl id="category" mb={3}>
                <FormLabel>
                  <Icon as={FaListAlt} mr={1} color="teal.500" />
                  Category
                </FormLabel>
                <Select
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  placeholder="Select category"
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                >
                  {categories.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.category}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <FormControl id="examDate" mb={3}>
                <FormLabel>
                  <Icon as={FaCalendarAlt} mr={1} color="teal.500" />
                  Exam Date
                </FormLabel>
                <Input
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  type="date"
                  value={examDate}
                  onChange={(e) => setExamDate(e.target.value)}
                />
              </FormControl>
              <FormControl id="class" mb={3}>
                <FormLabel>
                  <Icon as={FaChalkboardTeacher} mr={1} color="teal.500" />
                  Class
                </FormLabel>
                <Select
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  placeholder="Select class"
                  value={selectedClass}
                  onChange={(e) => setSelectedClass(e.target.value)}
                >
                  {classes.map((cls) => (
                    <option key={cls.id} value={cls.id}>
                      {cls.class}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <FormControl id="examName" mb={3}>
                <FormLabel>
                  <Icon as={FaClipboardList} mr={1} color="teal.500" />
                  Exam Name
                </FormLabel>
                <Input
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={examName}
                  onChange={(e) => setExamName(e.target.value)}
                />
              </FormControl>
              <FormControl id="maxMark" mb={3}>
                <FormLabel>
                  <Icon as={FaMarker} mr={1} color="teal.500" />
                  Max Mark
                </FormLabel>
                <Input
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  type="number"
                  value={maxMark}
                  onChange={(e) => setMaxMark(e.target.value)}
                />
              </FormControl>
              <FormControl id="passMark" mb={3}>
                <FormLabel>
                  <Icon as={FaPercent} mr={1} color="teal.500" />
                  Pass Mark
                </FormLabel>
                <Input
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  type="number"
                  value={passMark}
                  onChange={(e) => setPassMark(e.target.value)}
                />
              </FormControl>
              <FormControl id="staff" mb={3}>
                <FormLabel>
                  <Icon as={FaUserTie} mr={1} color="teal.500" />
                  Invigilator
                </FormLabel>
                <Select
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  placeholder="Select staff"
                  value={selectedStaff}
                  onChange={(e) => setSelectedStaff(e.target.value)}
                >
                  {filteredStaff.map((s) => (
                    <option key={s.id} value={s.id}>
                      {s.name}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <FormControl id="subject" mb={3}>
                <FormLabel>
                  <Icon as={FaBook} mr={1} color="teal.500" />
                  Subject
                </FormLabel>
                <Select
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  placeholder="Select subject"
                  value={selectedSubject}
                  onChange={(e) => setSelectedSubject(e.target.value)}
                >
                  {filteredSubjects.map((subject) => (
                    <option key={subject.id} value={subject.id}>
                      {subject.subject}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <FormControl
                id="classTest"
                display="flex"
                bg="white"
                _hover={{ borderColor: "teal.300" }}
                alignItems="center"
                mb={3}
              >
                <Checkbox
                  isChecked={isClassTest}
                  onChange={(e) => setIsClassTest(e.target.checked)}
                >
                  Class Test
                </Checkbox>
                <FormLabel ml={2}></FormLabel>
              </FormControl>
            </SimpleGrid>
          </ModalBody>
          <ModalFooter>
            <Button
              bgGradient="linear(to-r, teal.400, teal.600)"
              color="white"
              _hover={{ bgGradient: "linear(to-r, teal.500, teal.700)" }}
              mr={3}
              onClick={handleSubmit}
            >
              {isEditing ? "Update Exam" : "Create Exam"}
            </Button>
            {/* <Button variant="ghost" onClick={onClose}>
              Cancel
            </Button> */}
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Category Modal */}
      <Modal
        isOpen={isSectionOpen}
        onClose={onSectionClose}
        size="lg"
        motionPreset="slideInBottom"
      >
        <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
        <ModalContent
          borderRadius="lg"
          boxShadow="xl"
          bg="linear-gradient(135deg, #e0f7f7, #f0ffff)"
          color="gray.700"
          p={6}
          maxW="700px"
          maxH="550px"
          overflowY="auto"
        >
          <ModalHeader
            fontSize="xl"
            fontWeight="bold"
            textAlign="center"
            color="teal.600"
          >
            <Icon as={FaPlus} boxSize={5} mr={2} />
            Create Exam Category
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody
            overflowY="auto"
            px={4}
            css={{
              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-track": {
                background: "rgba(255, 255, 255, 0.2)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "rgba(173, 216, 230, 0.6)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "rgba(173, 216, 230, 0.9)",
              },
            }}
          >
            <FormControl id="category" mb={3}>
              <FormLabel>
                {" "}
                <Icon as={FaMarker} mr={1} color="teal.500" /> Category Name
              </FormLabel>
              <Input
                bg="white"
                _hover={{ borderColor: "teal.300" }}
                value={category}
                onChange={(e) => setCategory(e.target.value)}
              />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button
              bgGradient="linear(to-r, teal.400, teal.600)"
              color="white"
              _hover={{ bgGradient: "linear(to-r, teal.500, teal.700)" }}
              mr={3}
              onClick={handleCategorySubmit}
            >
              Create
            </Button>
            {/* <Button variant="ghost" onClick={onSectionClose}>
              Cancel
            </Button> */}
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default ExamDetails;
